export const anyFalsy = (fields, target) => {
  if (target) {
    return fields.some(field => !target[field]);
  }
  return fields.some(field => !field);
};
